import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function completeSignIn() {
      try {
        let { data, error: sessionError } = await supabase.auth.getSession();
        if (sessionError) throw sessionError;

        if (!data.session) {
          const params = new URLSearchParams(window.location.search);
          const code = params.get('code');
          if (code) {
            const { error: exchangeError } = await supabase.auth.exchangeCodeForSession(code);
            if (exchangeError) throw exchangeError;
            ({ data, error: sessionError } = await supabase.auth.getSession());
            if (sessionError) throw sessionError;
          }
        }

        if (!data.session) throw new Error('No authenticated session was created.');
        if (active) navigate('/', { replace: true });
      } catch (callbackError) {
        console.error(callbackError);
        if (active) setError('This login link could not be completed. Request a new one.');
      }
    }

    completeSignIn();
    return () => { active = false; };
  }, [navigate]);

  if (error) {
    return (
      <div className="center-screen">
        <div className="auth-card">
          <h1>Login link failed</h1>
          <p>{error}</p>
          <button className="primary-button" onClick={() => navigate('/login', { replace: true })}>Back to login</button>
        </div>
      </div>
    );
  }

  return <div className="center-screen"><div className="spinner" /></div>;
}
